/* allow users to deselect a checked radio button */
(function($) {

	$.fn.deselectradio = function() {

		return this.each(function() {
			var $this = $(this);

			$this.find(':radio').each(function(){
				var $radio = $(this);
				var $radioAndLabel = $radio.siblings('label').andSelf();
				$radioAndLabel.mousedown(function () {
					$radio.data('checked-state', $radio.prop('checked'));
				});
				$radioAndLabel.click(function () {
					if ($radio.data('checked-state')) {
						$radio.prop('checked', false);
					}
				});
			});
        });
	};
})(jQuery);